// extracted by mini-css-extract-plugin
export var container = "_1b-0";
export var disabled = "_1b-4";
export var fullWidth = "_1b-3";
export var lined = "_1b-1";
export var selected = "_1b-5";
export var tab = "_1b-2";